import React, { Component } from 'react';
import SubscriptionGateway from '../Components/SubscriptionGateway';
import Typography from '@material-ui/core/Typography';

let t;

class Subscription extends Component {
    constructor(props) {
        super(props);
        t = props.getTranslation;
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    getGatewayStyle(index, length) {
        if (length === 1) {
            return '';
        }

        return 'multiple-gateways-paper-style'
    }

    render() {
        const data = this.props.data;
        const gateways = data.gateways;

        const gatewaysContent = gateways.map((gateway, index) =>
            <div key={gateway.bpapi_gateway_id}>
                <div className='typography-title-container'>
                    <Typography variant="title">
                        {t('gateway')} {gateways.length > 1 ? (' ' + (index + 1)) : null}
                    </Typography>
                </div>
                <div className={this.getGatewayStyle(index, gateways.length)} key={gateway.bpapi_gateway_id}>

                    <SubscriptionGateway
                        updatePage={this.props.updatePage}
                        customer={this.props.data.customer}
                        usingValueCode={this.props.usingValueCode}
                        automaticLogin={this.props.automaticLogin}
                        setLoading={this.props.setLoading}
                        language={this.props.language}
                        simpleView={false}
                        updateAppData={this.props.updateAppData}
                        t={t}
                        credentials={this.props.credentials}
                        gateway={gateway}
                        updatePageWithProps={this.props.updatePageWithProps}
                        hasMultipleGateways={this.props.hasMultipleGateways} />
                </div>
            </div>


        );

        let content =
            <div className="content-frame">
                <div className="content">
                    <div className="content-container-subscription">
                        {gatewaysContent}
                        {/*
                    Todo: Add this here? Or maybe another place?
                    <h3>{t('faq')}</h3>
                    faqContent*/}
                    </div>
                </div>
            </div>;

        // Todo: This is ugly. Fix.
        if (this.props.isLoading) {
            content = null;
        }

        return (content);
    }
}

export default Subscription;


// WEBPACK FOOTER //
// ./src/Pages/Subscription.js